import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import VUSeal from './VUSeal'
import { supabase } from '../supabaseClient'
import './AuthPage.css'

export default function LoginPage() {
  const navigate = useNavigate()
  const [form, setForm] = useState({ email: '', password: '' })
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value })

  const handleSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)
    setError(null)
    try {
      const { error } = await supabase.auth.signInWithPassword({
        email: form.email,
        password: form.password,
      })
      if (error) throw error
      navigate('/dashboard')
    } catch (err) {
      setError(err.message)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="auth-wrap">
      <div className="auth-card">
        <div className="auth-seal"><VUSeal size={180} /></div>
        <h1 className="auth-title">Welcome back</h1>
        <p className="auth-sub">Sign in to your Vacatia University account</p>
        <form className="auth-form" onSubmit={handleSubmit}>
          <div className="auth-field">
            <label className="auth-lbl">Email address</label>
            <input className="auth-input" type="email" name="email" placeholder="name@vacatia.com" value={form.email} onChange={handleChange} required />
          </div>
          <div className="auth-field">
            <label className="auth-lbl">Password</label>
            <input className="auth-input" type="password" name="password" placeholder="Your password" value={form.password} onChange={handleChange} required />
          </div>
          {error && <p className="auth-error">{error}</p>}
          <button className="auth-submit" type="submit" disabled={loading}>{loading ? 'Signing in...' : 'Sign in'}</button>
        </form>
        <p className="auth-switch"><span onClick={() => navigate('/reset-password')} className="auth-link">Forgot your password?</span></p>
        <p className="auth-switch">Don't have an account? <span onClick={() => navigate('/')} className="auth-link">Create one</span></p>
      </div>
    </div>
  )
}
